<template>
    <home endpoint="location" :params="params"></home>
</template>

<script>
import home from '@/components/tools/Index'
export default {
  name: 'location',
  components: {
    home,
  },
  data () {
    return {
      params: {
        serverside: false,
        fields: [
          {name: 'id', label: 'Código', required: true},
          {name: 'Name', label: 'Nombre', required: true},
          {name: 'Closed', label: 'Cerrado', editor: 'checkbox'}],
        title: 'Ubicaciones',
        title2: 'Ubicación'
      }
    }
  },
}
</script>

